export const divider = {
  root: {
    borderColor: "{content.border.color}",
  },
  content: {
    background: "{content.background}",
    color: "{surface.border}",
  },
  horizontal: {
    margin: "0",
    padding: "{padding.8} 0",
    content: {
      padding: "0",
    },
  },
  // vertical: {
  //   margin: "0 1rem",
  //   padding: "0.5rem 0",
  //   content: {
  //     padding: "0.5rem 0",
  //   },
  // },
};
